import React from "react";
import "../index.scss";
import { BackArrowIcon } from "../../../../../../assets/images/svg/svg";
import { useNavigate } from "react-router-dom";

function BlogMain({ blogHead }) {
  const navigate = useNavigate();
  const imageUrl =
    blogHead?.blogHeadingImage?.[0]?.image?.data?.attributes?.url;
  return (
    <div className="head-main">
      <span className="back-arrow" onClick={() => navigate(-1)}>
        <BackArrowIcon /> Back
      </span>
      <h1 className="blog-title">{blogHead?.blogTitle}</h1>
      <desc className="blog-description">{blogHead?.shortDescription}</desc>
      {imageUrl && (
        <img
          src={imageUrl}
          alt={blogHead?.blogTitle || "Blog Image"}
          className="blog-image"
        />
      )}
    </div>
  );
}

export default BlogMain;
